import Theme from '@jetbrains/ring-ui-built/components/global/theme'
import {trackEvent} from '@jetbrains/teamcity-ui/dist/statistics'
import {useEffect} from 'react'

import {useAppDispatch, useAppSelector} from '../../../hooks/react-redux'
import {useBooleanUserProperty, useUserProperty} from '../../../hooks/useUserProperty'
import {getServerInfo} from '../../../selectors'
import {isWelcomePopupEnabled} from '../../../utils/featureToggles'
import {UserProperties} from '../../../utils/userProperties'

import WelcomePopup from './WelcomePopup'

import {openWhatsNew} from 'src/actions'
import {useDarkOrLightTheme} from 'src/hooks/theme/useDarkOrLightTheme'
import {useSetUserProperty} from 'src/hooks/useSetUserProperty'

function WelcomePopupContainer() {
  const showPopup = useBooleanUserProperty(UserProperties.SHOW_WELCOME_POPUP, true)
  const setUserProperty = useSetUserProperty()
  const dispatch = useAppDispatch()
  const onClose = () => {
    setUserProperty(UserProperties.SHOW_WELCOME_POPUP, 'false')
    trackEvent({name: 'close.click', groupId: 'welcomepopup.events.group'})
    dispatch(openWhatsNew())
  }
  const onCallToActionClick = () => onClose()

  const theme = useDarkOrLightTheme()
  const buildNumber = useAppSelector(state => getServerInfo(state)?.buildNumber)
  const userServerBuildNumber = useUserProperty(UserProperties.SERVER_BUILD_NUMBER)
  const isOldUser = Boolean(
    userServerBuildNumber && buildNumber && Number(userServerBuildNumber) < Number(buildNumber),
  )
  const canBeShown = isWelcomePopupEnabled() && isOldUser

  useEffect(() => {
    if (showPopup && canBeShown) {
      trackEvent({name: 'welcome.popup.open', groupId: 'welcomepopup.events.group'})
    }
  }, [canBeShown, showPopup])

  return (
    <WelcomePopup
      show={showPopup && canBeShown}
      isDark={theme === Theme.DARK}
      onClose={onClose}
      onCallToActionClick={onCallToActionClick}
    />
  )
}
export default WelcomePopupContainer
